import React, { useContext, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import avatar from "../../assets/images/avatar.svg";
import { ProfileSection } from "../../context/ProfileContext";
import { invitationAuthoritySet } from "../../api";
import { Alert } from "../";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UsersSettingComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const [openEditRoom, setOpenEditRoom] = useState(false);
  const invitedUser = useSelector((state) => state.invitedUser);
  const dashboardZones = useSelector(
    (state) => state.dashboardZones.dashboardZones
  );
  const dashboardDetails = useSelector((state) => state.dashboardDetails);
  const invitedUserSetting = useSelector((state) => state.invitedUserSetting);
  let zoneIds = [];
  let zones;
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  useEffect(() => {
    if (invitedUserSetting !== null) {
      zoneIds = invitedUserSetting?.map((item) => {
        return item.zone_uid;
      });
    }
  }, []);

  const handlechanged = (e, id) => {
    if (e.target.checked) {
      zoneIds.push(id);
      zones = zoneIds.filter((item, pos) => {
        let resualt = zoneIds.indexOf(item) == pos;
        return resualt.toString();
      });
    } else {
      zones = zoneIds.filter((e) => e !== id);
    }
  };

  const setSettings = () => {
    const data = new FormData();
    data.append("invitation", invitedUser.id);
    data.append("zones", zones);
    data.append("dashboard", dashboardDetails.id);
    invitationAuthoritySet(data, token)
      .then(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("تنظیمات با موفقیت ثبت شد."),
          type: "Success",
        }));
        setTimeout(() => {
          ProfileShowHideFunc("firstPage");
        }, 3000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  return (
    <>
      <div
        className="d-flex flex-column align-items-center mb-2"
        style={{ height: "20vh" }}
      >
        <img src={avatar} width="80" height="80" className="rounded-circle" />
        <p className="my-1">{invitedUser.name}</p>
        <p className="fn12 mb-1">{invitedUser.email}</p>
        {/* <p className="fn12 mb-1">09351649024</p> */}
      </div>
      {/* <div className="profileUsersStatus d-flex align-items-center m-auto">
                <i className="profileUsersStatusIcon icon-ok text-white text-center d-block mx-1"></i>
                <small className="text-white text-right fn10">دسترسی کامل</small>
            </div> */}
      <div className="mt-4">
        <p className="text-right fn mb-1" style={{ color: "#AEB3C0" }}>
          {t("دسترسی")}
        </p>
        <div className="invitedUserSetting">
          {dashboardZones?.map((zone, index) => {
            let invitedZoneId = invitedUserSetting?.filter((z) => {
              return z.zone_uid === zone.id;
            });
            return (
              <div
                key={index}
                className="d-flex justify-content-between align-items-center pt-2"
                style={{ borderBottom: "3px solid #EBEBEB" }}
              >
                <p className="m-0 fn12">{zone.zone_caption}</p>
                <label className="switch">
                  <input
                    type="checkbox"
                    id="myCheck"
                    defaultChecked={
                      invitedZoneId &&
                      invitedZoneId[0] &&
                      invitedZoneId[0]?.zone_uid === zone.id
                        ? true
                        : false
                    }
                    onChange={(e) => handlechanged(e, zone.id, index)}
                  />
                  <span className="switchSlider round"></span>
                </label>
              </div>
            );
          })}
          {/* <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderBottom: '3px solid #EBEBEB' }}>
                        <p className="m-0 fn12">دسترسی کامل</p>
                        <label class="switch">
                            <input type="checkbox" />
                            <span className="switchSlider round"></span>
                        </label>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderBottom: '3px solid #EBEBEB' }}>
                        <p className="m-0 fn12">حذف دستگاه</p>
                        <label className="switch">
                            <input type="checkbox" />
                            <span className="switchSlider round"></span>
                        </label>
                    </div>
                    <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderBottom: '3px solid #EBEBEB' }}>
                        <p className="m-0 fn12">تغییر دستگاه</p>
                        <label className="switch">
                            <input type="checkbox" />
                            <span className="switchSlider round"></span>
                        </label>
                    </div>
                    <div className="d-flex justify-content-between align-items-center cursor pb-2 pt-3"
                        style={{ borderBottom: '3px solid #EBEBEB' }}
                        onClick={() => setOpenEditRoom(true)}>
                        <div className="d-flex align-items-center">
                            <i className="ml-3 icon-house"></i>
                            <p className="m-0 fn12">خانه</p>
                        </div>
                        <i className="icon-down-open-big fn12 rotateIcon"></i>
                    </div>
                    <div className="d-flex justify-content-between align-items-center cursor pb-2 pt-3"
                        style={{ borderBottom: '3px solid #EBEBEB' }}>
                        <div className="d-flex">
                            <i className="ml-3">i</i>
                            <p className="m-0 fn12">حذف کاربر</p>
                        </div>
                        <i className="icon-down-open-big fn12 rotateIcon"></i>
                    </div> */}
        </div>
      </div>
      <div
        className="d-flex justify-content-center mt-3"
        style={{ height: "12vh" }}
      >
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span
            className="profileAddUser bg-white d-block icon-ok cursor"
            onClick={setSettings}
          ></span>
          <small className="fn10 mt-1">{t("تائید")}</small>
        </div>
        <div className="mx-3 d-flex justify-content-center align-items-center flex-column text-center">
          <span
            className="profileAddUser bg-white d-block icon-left-1 cursor"
            onClick={() => ProfileShowHideFunc("firstPage")}
          ></span>
          <small className="fn10 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
      {/* {
                openEditRoom &&
                <div className="editHomeSection position-absolute w-100 px-3 text-right pb-5">
                    <div className="cursor p-2" onClick={() => setOpenEditRoom(!openEditRoom)}>
                        <div className="hr m-auto"></div>
                    </div>
                    {dashboardZones?.map((zone, index) => {
                        console.log(zone)
                        return (
                            <div key={index}
                                className="d-flex justify-content-between align-items-center pt-2"
                                style={{ borderBottom: '3px solid #EBEBEB' }}>
                                <p className="m-0 fn12">{zone.zone_caption}</p>
                                <label className="switch">
                                    <input type="checkbox" />
                                    <span className="switchSlider round"></span>
                                </label>
                            </div>
                        )
                    })}
                </div>
            } */}
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </>
  );
};

const UsersSetting = withRouter(UsersSettingComp);

export { UsersSetting };
